<template>
  <ankh-list :showPager="false">
    <template #btn-group>
      <el-button @click="handleSaveSubmit">{{ $t('保存更改') }}</el-button>
      <el-button @click.native="$refs.treeTable.handleChangeExpandState()">{{expandState ? $t('收起') : $t('展开')}}</el-button>
      <el-button @click.native="handleBatchDelete">{{ $t('批量删除') }}</el-button>
    </template>

    <template #search-form>
      <el-form-item :label="$t('名称')">
        <el-input :placeholder="$t('名称')" v-model="searchForm.name" clearable />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSearch()">{{ $t('搜索') }}</el-button>
        <el-button @click="resetEmpty()">{{ $t('重置') }}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">

      <tree-table :column-list="columnList"
                  :data.sync="tableData"
                  :expand.sync="expandState"
                  :height="height" ref="treeTable"
                  :row-template="rowTemplate">
        <template #content="{row}">
          <el-input :placeholder="$t('内容描述')" v-model="row.content" type="textarea" :rows="3" />
        </template>

        <template #photo="{row}">
          <pic-upload
              v-model="row.photo"
              :action="$api.file.upload"
              :limit="1"
              :download-url="$api.file.downloadImg"
              width="80px"
              height="80px" />
        </template>

        <template #priority="{row}">
          <el-input-number v-model="row.priority" />
        </template>


        <template #operate="{row}">
          <div class="fb-link-flex">
            <el-link type="danger" :underline="false" @click="handleDelete(row)">{{ $t('删除') }}</el-link>
            <el-link type="primary" :underline="false" @click="$router.push('dynamic?code=' + row.code)">{{ $t('查看') }}</el-link>
          </div>
        </template>
      </tree-table>
    </template>
  </ankh-list>
</template>

<script>
import {request} from "@/config/request";
import PicUpload from "@/components/pic-upload/PicUpload";
import {handleBuildTreeData, handleDeleteTip, handleDeleteTreeNode} from "@/utils/levelUtils";
import AnkhList from "@/components/list/AnkhList.vue";
import TreeTable from "@/components/tree-table/TreeTable.vue";
import {resetEmpty} from "@/utils/common";

export default {
  name: "TopicDetail",
  components: {TreeTable, AnkhList, PicUpload},
  data() {
    return {
      searchForm: {},
      tableData: [],

      rowTemplate: {
        name: "",
        expand: "no",
        createTimeStr: this.$moment().format("YYYY-MM-DD HH:mm:ss")
      },
      expandState: true,

      columnList: [
        {label: "名称", prop: "name", type: "input"},
        {label: "内容描述", prop: "content"},
        {label: "图片", prop: "photo"},
        {label: "参与人数", prop: "joinCount"},
        {label: "优先级", prop: "priority"},
        {label: "移动", prop: "", type: "more"},
        {label: "创建时间", prop: "createTimeStr"},
        {label: "操作", prop: "operate"},
      ],
    }
  },
  methods: {
    resetEmpty,
    // 保存
    async handleSaveSubmit() {
      try {
        const topicSortBeans = this.handleBuildParams(this.tableData);
        let params = {
          topicSortBeans,
          parentCode: this.$route.query.code,
        }
        await request(this.$api.topicSort.saveSecond, params, {isJson: true});
        this.$message.success(this.$t('保存成功'));
        await this.handleSearch();
      }catch(e) {
        console.log(e);
      }
    },

    // 处理数据
    handleBuildParams(list) {
      return list.map((item, index) => {
        let sub = [];
        if(item.sub.length) {
          sub = this.handleBuildParams(item.sub);
        }
        return {
          name: item.name,
          code: item.isNewAdd ? null : item.code,
          photo: item.photo,
          priority: item.priority,
          content: item.content,
          sort: index + 1,
          expand: item.expand,
          sub,
        }
      })
    },

    async handleDelete(row) {
      try {
        await handleDeleteTip();
        if (!row.isNewAdd) {
          await request(this.$api.topicSort.delete, {code: row.code});
        }
        this.tableData = handleDeleteTreeNode([row.code], this.tableData);
        this.$message.success(this.$t('操作成功'));
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      const selected = this.$refs.treeTable.handleGetSelected();
      if (!selected.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }
      try {
        await handleDeleteTip();
        let codes = selected.filter(f => !f.isNewAdd).map(item => item.code);
        if (codes.length) {
          await request(
              this.$api.topicSort.batchDelete,
              codes,
              {isJson: true},
          );
        }
        const delCodes = selected.map(item => item.code);
        this.$message.success(this.$t('操作成功'));
        this.tableData = handleDeleteTreeNode(delCodes, this.tableData);

      } catch (e) {
        console.error(e);
      }
    },


    async handleSearch() {
      try {
        const params = {
          ...this.searchForm,
          parentTree: this.$route.query.code,
          onPage: false,
        }
        let res = await request(this.$api.topicSort.listSecond, params);
        const list = res.foodSorts.map(item => {
          item.parentCode = null;
          item.createTimeStr = this.$moment(item.createTime).format("YYYY-MM-DD HH:mm:ss");
          return item;
        })
        this.tableData = handleBuildTreeData(list);
      } catch (e) {
        console.error(e);
      }
    }
  },
  mounted() {
    this.handleSearch();
  }
}
</script>

<style scoped>

/deep/ .cell {
  display: flex;
  align-items: center;
}

/deep/ .warning-row {
  background: oldlace;
}

/deep/ .success-row {
  background: #f0f9eb;
}

/deep/ .red {
  background: red;
}

</style>
